export const COUNTRY_DETAILS = [
    {
        "name": "Andorra",
        "ISO_3166_1_ALPHA_2": "AD",
        "ISO_3166_1_ALPHA_3": "AND",
        "centralLat": 42.546245,
        "centralLng": 1.601554,
        "region": "Europe"
    },
    {
        "name": "United Arab Emirates",
        "ISO_3166_1_ALPHA_2": "AE",
        "ISO_3166_1_ALPHA_3": "ARE",
        "centralLat": 23.424076,
        "centralLng": 53.847818,
        "region": "MENA"
    },
    {
        "name": "Afghanistan",
        "ISO_3166_1_ALPHA_2": "AF",
        "ISO_3166_1_ALPHA_3": "AFG",
        "centralLat": 33.93911,
        "centralLng": 67.709953,
        "region": "APAC"
    },
    {
        "name": "Antigua and Barbuda",
        "ISO_3166_1_ALPHA_2": "AG",
        "ISO_3166_1_ALPHA_3": "ATG",
        "centralLat": 17.060816,
        "centralLng": -61.796428,
        "region": "Americas"
    },
    {
        "name": "Anguilla",
        "ISO_3166_1_ALPHA_2": "AI",
        "ISO_3166_1_ALPHA_3": "AIA",
        "centralLat": 18.220554,
        "centralLng": -63.068615,
        "region": "Americas"
    },
    {
        "name": "Albania",
        "ISO_3166_1_ALPHA_2": "AL",
        "ISO_3166_1_ALPHA_3": "ALB",
        "centralLat": 41.153332,
        "centralLng": 20.168331,
        "region": "Europe"
    },
    {
        "name": "Armenia",
        "ISO_3166_1_ALPHA_2": "AM",
        "ISO_3166_1_ALPHA_3": "ARM",
        "centralLat": 40.069099,
        "centralLng": 45.038189,
        "region": "APAC"
    },
    {
        "name": "Netherlands Antilles",
        "ISO_3166_1_ALPHA_2": "AN",
        "ISO_3166_1_ALPHA_3": null,        
        "centralLat": 12.226079,
        "centralLng": -69.060087,
        "region": "Americas"
    },
    {
        "name": "Angola",
        "ISO_3166_1_ALPHA_2": "AO",
        "ISO_3166_1_ALPHA_3": "AGO",
        "centralLat": -11.202692,
        "centralLng": 17.873887,
        "region": "Africa"
    },
    {
        "name": "Antarctica",
        "ISO_3166_1_ALPHA_2": "AQ",
        "ISO_3166_1_ALPHA_3": "ATA",
        "centralLat": -75.250973,
        "centralLng": -0.071389,
        "region": "APAC"
    },
    {
        "name": "Argentina",
        "ISO_3166_1_ALPHA_2": "AR",
        "ISO_3166_1_ALPHA_3": "ARG",
        "centralLat": -38.416097,
        "centralLng": -63.616672,
        "region": "Americas"
    },
    {
        "name": "American Samoa",
        "ISO_3166_1_ALPHA_2": "AS",
        "ISO_3166_1_ALPHA_3": "ASM",
        "centralLat": -14.270972,
        "centralLng": -170.132217,
        "region": "APAC"
    },
    {
        "name": "Austria",
        "ISO_3166_1_ALPHA_2": "AT",
        "ISO_3166_1_ALPHA_3": "AUT",
        "centralLat": 47.516231,
        "centralLng": 14.550072,
        "region": "Europe"
    },
    {
        "name": "Australia",
        "ISO_3166_1_ALPHA_2": "AU",
        "ISO_3166_1_ALPHA_3": "AUS",
        "centralLat": -25.274398,
        "centralLng": 133.775136,
        "region": "APAC"
    },
    {
        "name": "Aruba",
        "ISO_3166_1_ALPHA_2": "AW",
        "ISO_3166_1_ALPHA_3": "ABW",
        "centralLat": 12.52111,
        "centralLng": -69.968338,
        "region": "Americas"
    },
    {
        "name": "Azerbaijan",
        "ISO_3166_1_ALPHA_2": "AZ",
        "ISO_3166_1_ALPHA_3": "AZE",
        "centralLat": 40.143105,
        "centralLng": 47.576927,
        "region": "APAC"
    },
    {
        "name": "Bosnia and Herzegovina",
        "ISO_3166_1_ALPHA_2": "BA",
        "ISO_3166_1_ALPHA_3": "BIH",
        "centralLat": 43.915886,
        "centralLng": 17.679076,
        "region": "Europe"
    },
    {
        "name": "Barbados",
        "ISO_3166_1_ALPHA_2": "BB",
        "ISO_3166_1_ALPHA_3": "BRB",
        "centralLat": 13.193887,
        "centralLng": -59.543198,
        "region": "Americas"
    },
    {
        "name": "Bangladesh",
        "ISO_3166_1_ALPHA_2": "BD",
        "ISO_3166_1_ALPHA_3": "BGD",
        "centralLat": 23.684994,
        "centralLng": 90.356331,
        "region": "APAC"
    },
    {
        "name": "Belgium",
        "ISO_3166_1_ALPHA_2": "BE",
        "ISO_3166_1_ALPHA_3": "BEL",
        "centralLat": 50.503887,
        "centralLng": 4.469936,
        "region": "Europe"
    },
    {
        "name": "Burkina Faso",
        "ISO_3166_1_ALPHA_2": "BF",
        "ISO_3166_1_ALPHA_3": "BFA",
        "centralLat": 12.238333,
        "centralLng": -1.561593,
        "region": "Africa"
    },
    {
        "name": "Bulgaria",
        "ISO_3166_1_ALPHA_2": "BG",
        "ISO_3166_1_ALPHA_3": "BGR",
        "centralLat": 42.733883,
        "centralLng": 25.48583,
        "region": "Europe"
    },
    {
        "name": "Bahrain",
        "ISO_3166_1_ALPHA_2": "BH",
        "ISO_3166_1_ALPHA_3": "BHR",
        "centralLat": 25.930414,
        "centralLng": 50.637772,
        "region": "MENA"
    },
    {
        "name": "Burundi",
        "ISO_3166_1_ALPHA_2": "BI",
        "ISO_3166_1_ALPHA_3": "BDI",
        "centralLat": -3.373056,
        "centralLng": 29.918886,
        "region": "Africa"
    },
    {
        "name": "Benin",
        "ISO_3166_1_ALPHA_2": "BJ",
        "ISO_3166_1_ALPHA_3": "BEN",
        "centralLat": 9.30769,
        "centralLng": 2.315834,
        "region": "Africa"
    },
    {
        "name": "Bermuda",
        "ISO_3166_1_ALPHA_2": "BM",
        "ISO_3166_1_ALPHA_3": "BMU",
        "centralLat": 32.321384,
        "centralLng": -64.75737,
        "region": "Americas"
    },
    {
        "name": "Brunei",
        "ISO_3166_1_ALPHA_2": "BN",
        "ISO_3166_1_ALPHA_3": "BRN",
        "centralLat": 4.535277,
        "centralLng": 114.727669,
        "region": "APAC"
    },
    {
        "name": "Bolivia",
        "ISO_3166_1_ALPHA_2": "BO",
        "ISO_3166_1_ALPHA_3": "BOL",
        "centralLat": -16.290154,
        "centralLng": -63.588653,
        "region": "Americas"
    },
    {
        "name": "Brazil",
        "ISO_3166_1_ALPHA_2": "BR",
        "ISO_3166_1_ALPHA_3": "BRA",
        "centralLat": -14.235004,
        "centralLng": -51.92528,
        "region": "Americas"
    },
    {
        "name": "Bahamas",
        "ISO_3166_1_ALPHA_2": "BS",
        "ISO_3166_1_ALPHA_3": "BHS",
        "centralLat": 25.03428,
        "centralLng": -77.39628,
        "region": "Americas"
    },
    {
        "name": "Bhutan",
        "ISO_3166_1_ALPHA_2": "BT",
        "ISO_3166_1_ALPHA_3": "BTN",
        "centralLat": 27.514162,
        "centralLng": 90.433601,
        "region": "APAC"
    },
    {
        "name": "Bouvet Island",
        "ISO_3166_1_ALPHA_2": "BV",
        "ISO_3166_1_ALPHA_3": "BVT",
        "centralLat": -54.423199,
        "centralLng": 3.413194,
        "region": "Americas"
    },
    {
        "name": "Botswana",
        "ISO_3166_1_ALPHA_2": "BW",
        "ISO_3166_1_ALPHA_3": "BWA",
        "centralLat": -22.328474,
        "centralLng": 24.684866,
        "region": "Africa"
    },
    {
        "name": "Belarus",
        "ISO_3166_1_ALPHA_2": "BY",
        "ISO_3166_1_ALPHA_3": "BLR",
        "centralLat": 53.709807,
        "centralLng": 27.953389,
        "region": "Europe"
    },
    {
        "name": "Belize",
        "ISO_3166_1_ALPHA_2": "BZ",
        "ISO_3166_1_ALPHA_3": "BLZ",
        "centralLat": 17.189877,
        "centralLng": -88.49765,
        "region": "Americas"
    },
    {
        "name": "Canada",
        "ISO_3166_1_ALPHA_2": "CA",
        "ISO_3166_1_ALPHA_3": "CAN",
        "centralLat": 56.130366,
        "centralLng": -106.346771,
        "region": "Americas"
    },
    {
        "name": "Cocos [Keeling] Islands",
        "ISO_3166_1_ALPHA_2": "CC",
        "ISO_3166_1_ALPHA_3": "CCK",
        "centralLat": -12.164165,
        "centralLng": 96.870956,
        "region": "APAC"
    },
    {
        "name": "Congo [DRC]",
        "ISO_3166_1_ALPHA_2": "CD",
        "ISO_3166_1_ALPHA_3": "COD",
        "centralLat": -4.038333,
        "centralLng": 21.758664,
        "region": "Africa"
    },
    {
        "name": "Central African Republic",
        "ISO_3166_1_ALPHA_2": "CF",
        "ISO_3166_1_ALPHA_3": "CAF",
        "centralLat": 6.611111,
        "centralLng": 20.939444,
        "region": "Africa"
    },
    {
        "name": "Congo [Republic]",
        "ISO_3166_1_ALPHA_2": "CG",
        "ISO_3166_1_ALPHA_3": "COG",
        "centralLat": -0.228021,
        "centralLng": 15.827659,
        "region": "Africa"
    },
    {
        "name": "Switzerland",
        "ISO_3166_1_ALPHA_2": "CH",
        "ISO_3166_1_ALPHA_3": "CHE",
        "centralLat": 46.818188,
        "centralLng": 8.227512,
        "region": "Europe"
    },
    {
        "name": "Côte d'Ivoire",
        "ISO_3166_1_ALPHA_2": "CI",
        "ISO_3166_1_ALPHA_3": "CIV",
        "centralLat": 7.539989,
        "centralLng": -5.54708,
        "region": "Africa"
    },
    {
        "name": "Cook Islands",
        "ISO_3166_1_ALPHA_2": "CK",
        "ISO_3166_1_ALPHA_3": "COK",
        "centralLat": -21.236736,
        "centralLng": -159.777671,
        "region": "APAC"
    },
    {
        "name": "Chile",
        "ISO_3166_1_ALPHA_2": "CL",
        "ISO_3166_1_ALPHA_3": "CHL",
        "centralLat": -35.675147,
        "centralLng": -71.542969,
        "region": "Americas"
    },
    {
        "name": "Cameroon",
        "ISO_3166_1_ALPHA_2": "CM",
        "ISO_3166_1_ALPHA_3": "CMR",
        "centralLat": 7.369722,
        "centralLng": 12.354722,
        "region": "Africa"
    },
    {
        "name": "China",
        "ISO_3166_1_ALPHA_2": "CN",
        "ISO_3166_1_ALPHA_3": "CHN",
        "centralLat": 35.86166,
        "centralLng": 104.195397,
        "region": "APAC"
    },
    {
        "name": "Colombia",
        "ISO_3166_1_ALPHA_2": "CO",
        "ISO_3166_1_ALPHA_3": "COL",
        "centralLat": 4.570868,
        "centralLng": -74.297333,
        "region": "Americas"
    },
    {
        "name": "Costa Rica",
        "ISO_3166_1_ALPHA_2": "CR",
        "ISO_3166_1_ALPHA_3": "CRI",
        "centralLat": 9.748917,
        "centralLng": -83.753428,
        "region": "Americas"
    },
    {
        "name": "Cuba",
        "ISO_3166_1_ALPHA_2": "CU",
        "ISO_3166_1_ALPHA_3": "CUB",
        "centralLat": 21.521757,
        "centralLng": -77.781167,
        "region": "Americas"
    },
    {
        "name": "Cape Verde",
        "ISO_3166_1_ALPHA_2": "CV",
        "ISO_3166_1_ALPHA_3": "CPV",
        "centralLat": 16.002082,
        "centralLng": -24.013197,
        "region": "Africa"
    },
    {
        "name": "Christmas Island",
        "ISO_3166_1_ALPHA_2": "CX",
        "ISO_3166_1_ALPHA_3": "CXR",
        "centralLat": -10.447525,
        "centralLng": 105.690449,
        "region": "APAC"
    },
    {
        "name": "Cyprus",
        "ISO_3166_1_ALPHA_2": "CY",
        "ISO_3166_1_ALPHA_3": "CYP",
        "centralLat": 35.126413,
        "centralLng": 33.429859,
        "region": "APAC"
    },
    {
        "name": "Czech Republic",
        "ISO_3166_1_ALPHA_2": "CZ",
        "ISO_3166_1_ALPHA_3": "CZE",
        "centralLat": 49.817492,
        "centralLng": 15.472962,
        "region": "Europe"
    },
    {
        "name": "Germany",
        "ISO_3166_1_ALPHA_2": "DE",
        "ISO_3166_1_ALPHA_3": "DEU",
        "centralLat": 51.165691,
        "centralLng": 10.451526,
        "region": "Europe"
    },
    {
        "name": "Djibouti",
        "ISO_3166_1_ALPHA_2": "DJ",
        "ISO_3166_1_ALPHA_3": "DJI",
        "centralLat": 11.825138,
        "centralLng": 42.590275,
        "region": "Africa"
    },
    {
        "name": "Denmark",
        "ISO_3166_1_ALPHA_2": "DK",
        "ISO_3166_1_ALPHA_3": "DNK",
        "centralLat": 56.26392,
        "centralLng": 9.501785,
        "region": "Europe"
    },
    {
        "name": "Dominica",
        "ISO_3166_1_ALPHA_2": "DM",
        "ISO_3166_1_ALPHA_3": "DMA",
        "centralLat": 15.414999,
        "centralLng": -61.370976,
        "region": "Americas"
    },
    {
        "name": "Dominican Republic",
        "ISO_3166_1_ALPHA_2": "DO",
        "ISO_3166_1_ALPHA_3": "DOM",
        "centralLat": 18.735693,
        "centralLng": -70.162651,
        "region": "Americas"
    },
    {
        "name": "Algeria",
        "ISO_3166_1_ALPHA_2": "DZ",
        "ISO_3166_1_ALPHA_3": "DZA",
        "centralLat": 28.033886,
        "centralLng": 1.659626,
        "region": "MENA"
    },
    {
        "name": "Ecuador",
        "ISO_3166_1_ALPHA_2": "EC",
        "ISO_3166_1_ALPHA_3": "ECU",
        "centralLat": -1.831239,
        "centralLng": -78.183406,
        "region": "Americas"
    },
    {
        "name": "Estonia",
        "ISO_3166_1_ALPHA_2": "EE",
        "ISO_3166_1_ALPHA_3": "EST",
        "centralLat": 58.595272,
        "centralLng": 25.013607,
        "region": "Europe"
    },
    {
        "name": "Egypt",
        "ISO_3166_1_ALPHA_2": "EG",
        "ISO_3166_1_ALPHA_3": "EGY",
        "centralLat": 26.820553,
        "centralLng": 30.802498,
        "region": "MENA"
    },
    {
        "name": "Western Sahara",
        "ISO_3166_1_ALPHA_2": "EH",
        "ISO_3166_1_ALPHA_3": "ESH",
        "centralLat": 24.215527,
        "centralLng": -12.885834,
        "region": "Africa"
    },
    {
        "name": "Eritrea",
        "ISO_3166_1_ALPHA_2": "ER",
        "ISO_3166_1_ALPHA_3": "ERI",
        "centralLat": 15.179384,
        "centralLng": 39.782334,
        "region": "Africa"
    },
    {
        "name": "Spain",
        "ISO_3166_1_ALPHA_2": "ES",
        "ISO_3166_1_ALPHA_3": "ESP",
        "centralLat": 40.463667,
        "centralLng": -3.74922,
        "region": "Europe"
    },
    {
        "name": "Ethiopia",
        "ISO_3166_1_ALPHA_2": "ET",
        "ISO_3166_1_ALPHA_3": "ETH",
        "centralLat": 9.145,
        "centralLng": 40.489673,
        "region": "Africa"
    },
    {
        "name": "Finland",
        "ISO_3166_1_ALPHA_2": "FI",
        "ISO_3166_1_ALPHA_3": "FIN",
        "centralLat": 61.92411,
        "centralLng": 25.748151,
        "region": "Europe"
    },
    {
        "name": "Fiji",
        "ISO_3166_1_ALPHA_2": "FJ",
        "ISO_3166_1_ALPHA_3": "FJI",
        "centralLat": -16.578193,
        "centralLng": 179.414413,
        "region": "APAC"
    },
    {
        "name": "Falkland Islands [Islas Malvinas]",
        "ISO_3166_1_ALPHA_2": "FK",
        "ISO_3166_1_ALPHA_3": "FLK",
        "centralLat": -51.796253,
        "centralLng": -59.523613,
        "region": "Americas"
    },
    {
        "name": "Micronesia",
        "ISO_3166_1_ALPHA_2": "FM",
        "ISO_3166_1_ALPHA_3": "FSM",
        "centralLat": 7.425554,
        "centralLng": 150.550812,
        "region": "APAC"
    },
    {
        "name": "Faroe Islands",
        "ISO_3166_1_ALPHA_2": "FO",
        "ISO_3166_1_ALPHA_3": "FRO",
        "centralLat": 61.892635,
        "centralLng": -6.911806,
        "region": "Europe"
    },
    {
        "name": "France",
        "ISO_3166_1_ALPHA_2": "FR",
        "ISO_3166_1_ALPHA_3": "FRA",
        "centralLat": 46.227638,
        "centralLng": 2.213749,
        "region": "Europe"
    },
    {
        "name": "Gabon",
        "ISO_3166_1_ALPHA_2": "GA",
        "ISO_3166_1_ALPHA_3": "GAB",
        "centralLat": -0.803689,
        "centralLng": 11.609444,
        "region": "Africa"
    },
    {
        "name": "United Kingdom",
        "ISO_3166_1_ALPHA_2": "GB",
        "ISO_3166_1_ALPHA_3": "GBR",
        "centralLat": 55.378051,
        "centralLng": -3.435973,
        "region": "Europe"
    },
    {
        "name": "Grenada",
        "ISO_3166_1_ALPHA_2": "GD",
        "ISO_3166_1_ALPHA_3": "GRD",
        "centralLat": 12.262776,
        "centralLng": -61.604171,
        "region": "Americas"
    },
    {
        "name": "Georgia",
        "ISO_3166_1_ALPHA_2": "GE",
        "ISO_3166_1_ALPHA_3": "GEO",
        "centralLat": 42.315407,
        "centralLng": 43.356892,
        "region": "APAC"
    },
    {
        "name": "French Guiana",
        "ISO_3166_1_ALPHA_2": "GF",
        "ISO_3166_1_ALPHA_3": "GUF",
        "centralLat": 3.933889,
        "centralLng": -53.125782,
        "region": "Americas"
    },
    {
        "name": "Guernsey",
        "ISO_3166_1_ALPHA_2": "GG",
        "ISO_3166_1_ALPHA_3": "GGY",
        "centralLat": 49.465691,
        "centralLng": -2.585278,
        "region": "Europe"
    },
    {
        "name": "Ghana",
        "ISO_3166_1_ALPHA_2": "GH",
        "ISO_3166_1_ALPHA_3": "GHA",
        "centralLat": 7.946527,
        "centralLng": -1.023194,
        "region": "Africa"
    },
    {
        "name": "Gibraltar",
        "ISO_3166_1_ALPHA_2": "GI",
        "ISO_3166_1_ALPHA_3": "GIB",
        "centralLat": 36.137741,
        "centralLng": -5.345374,
        "region": "Europe"
    },
    {
        "name": "Greenland",
        "ISO_3166_1_ALPHA_2": "GL",
        "ISO_3166_1_ALPHA_3": "GRL",
        "centralLat": 71.706936,
        "centralLng": -42.604303,
        "region": "Americas"
    },
    {
        "name": "Gambia",
        "ISO_3166_1_ALPHA_2": "GM",
        "ISO_3166_1_ALPHA_3": "GMB",
        "centralLat": 13.443182,
        "centralLng": -15.310139,
        "region": "Africa"
    },
    {
        "name": "Guinea",
        "ISO_3166_1_ALPHA_2": "GN",
        "ISO_3166_1_ALPHA_3": "GIN",
        "centralLat": 9.945587,
        "centralLng": -9.696645,
        "region": "Africa"
    },
    {
        "name": "Guadeloupe",
        "ISO_3166_1_ALPHA_2": "GP",
        "ISO_3166_1_ALPHA_3": "GLP",
        "centralLat": 16.995971,
        "centralLng": -62.067641,
        "region": "Americas"
    },
    {
        "name": "Equatorial Guinea",
        "ISO_3166_1_ALPHA_2": "GQ",
        "ISO_3166_1_ALPHA_3": "GNQ",
        "centralLat": 1.650801,
        "centralLng": 10.267895,
        "region": "Africa"
    },
    {
        "name": "Greece",
        "ISO_3166_1_ALPHA_2": "GR",
        "ISO_3166_1_ALPHA_3": "GRC",
        "centralLat": 39.074208,
        "centralLng": 21.824312,
        "region": "Europe"
    },
    {
        "name": "South Georgia and the South Sandwich Islands",
        "ISO_3166_1_ALPHA_2": "GS",
        "ISO_3166_1_ALPHA_3": "SGS",
        "centralLat": -54.429579,
        "centralLng": -36.587909,
        "region": "Americas"
    },
    {
        "name": "Guatemala",
        "ISO_3166_1_ALPHA_2": "GT",
        "ISO_3166_1_ALPHA_3": "GTM",
        "centralLat": 15.783471,
        "centralLng": -90.230759,
        "region": "Americas"
    },
    {
        "name": "Guam",
        "ISO_3166_1_ALPHA_2": "GU",
        "ISO_3166_1_ALPHA_3": "GUM",
        "centralLat": 13.444304,
        "centralLng": 144.793731,
        "region": "APAC"
    },
    {
        "name": "Guinea-Bissau",
        "ISO_3166_1_ALPHA_2": "GW",
        "ISO_3166_1_ALPHA_3": "GNB",
        "centralLat": 11.803749,
        "centralLng": -15.180413,
        "region": "Africa"
    },
    {
        "name": "Guyana",
        "ISO_3166_1_ALPHA_2": "GY",
        "ISO_3166_1_ALPHA_3": "GUY",
        "centralLat": 4.860416,
        "centralLng": -58.93018,
        "region": "Americas"
    },
    {
        "name": "Gaza Strip",
        "ISO_3166_1_ALPHA_2": "GZ",
        "ISO_3166_1_ALPHA_3": null,        
        "centralLat": 31.354676,
        "centralLng": 34.308825,
        "region": "MENA"
    },
    {
        "name": "Hong Kong",
        "ISO_3166_1_ALPHA_2": "HK",
        "ISO_3166_1_ALPHA_3": "HKG",
        "centralLat": 22.396428,
        "centralLng": 114.109497,
        "region": "APAC"
    },
    {
        "name": "Heard Island and McDonald Islands",
        "ISO_3166_1_ALPHA_2": "HM",
        "ISO_3166_1_ALPHA_3": "HMD",
        "centralLat": -53.08181,
        "centralLng": 73.504158,
        "region": "APAC"
    },
    {
        "name": "Honduras",
        "ISO_3166_1_ALPHA_2": "HN",
        "ISO_3166_1_ALPHA_3": "HND",
        "centralLat": 15.199999,
        "centralLng": -86.241905,
        "region": "Americas"
    },
    {
        "name": "Croatia",
        "ISO_3166_1_ALPHA_2": "HR",
        "ISO_3166_1_ALPHA_3": "HRV",
        "centralLat": 45.1,
        "centralLng": 15.2,
        "region": "Europe"
    },
    {
        "name": "Haiti",
        "ISO_3166_1_ALPHA_2": "HT",
        "ISO_3166_1_ALPHA_3": "HTI",
        "centralLat": 18.971187,
        "centralLng": -72.285215,
        "region": "Americas"
    },
    {
        "name": "Hungary",
        "ISO_3166_1_ALPHA_2": "HU",
        "ISO_3166_1_ALPHA_3": "HUN",
        "centralLat": 47.162494,
        "centralLng": 19.503304,
        "region": "Europe"
    },
    {
        "name": "Indonesia",
        "ISO_3166_1_ALPHA_2": "ID",
        "ISO_3166_1_ALPHA_3": "IDN",
        "centralLat": -0.789275,
        "centralLng": 113.921327,
        "region": "APAC"
    },
    {
        "name": "Ireland",
        "ISO_3166_1_ALPHA_2": "IE",
        "ISO_3166_1_ALPHA_3": "IRL",
        "centralLat": 53.41291,
        "centralLng": -8.24389,
        "region": "Europe"
    },
    {
        "name": "Israel",
        "ISO_3166_1_ALPHA_2": "IL",
        "ISO_3166_1_ALPHA_3": "ISR",
        "centralLat": 31.046051,
        "centralLng": 34.851612,
        "region": "MENA"
    },
    {
        "name": "Isle of Man",
        "ISO_3166_1_ALPHA_2": "IM",
        "ISO_3166_1_ALPHA_3": "IMN",
        "centralLat": 54.236107,
        "centralLng": -4.548056,
        "region": "Europe"
    },
    {
        "name": "India",
        "ISO_3166_1_ALPHA_2": "IN",
        "ISO_3166_1_ALPHA_3": "IND",
        "centralLat": 20.593684,
        "centralLng": 78.96288,
        "region": "APAC"
    },
    {
        "name": "British Indian Ocean Territory",
        "ISO_3166_1_ALPHA_2": "IO",
        "ISO_3166_1_ALPHA_3": "IOT",
        "centralLat": -6.343194,
        "centralLng": 71.876519,
        "region": "APAC"
    },
    {
        "name": "Iraq",
        "ISO_3166_1_ALPHA_2": "IQ",
        "ISO_3166_1_ALPHA_3": "IRQ",
        "centralLat": 33.223191,
        "centralLng": 43.679291,
        "region": "MENA"
    },
    {
        "name": "Iran",
        "ISO_3166_1_ALPHA_2": "IR",
        "ISO_3166_1_ALPHA_3": "IRN",
        "centralLat": 32.427908,
        "centralLng": 53.688046,
        "region": "MENA"
    },
    {
        "name": "Iceland",
        "ISO_3166_1_ALPHA_2": "IS",
        "ISO_3166_1_ALPHA_3": "ISL",
        "centralLat": 64.963051,
        "centralLng": -19.020835,
        "region": "Europe"
    },
    {
        "name": "Italy",
        "ISO_3166_1_ALPHA_2": "IT",
        "ISO_3166_1_ALPHA_3": "ITA",
        "centralLat": 41.87194,
        "centralLng": 12.56738,
        "region": "Europe"
    },
    {
        "name": "Jersey",
        "ISO_3166_1_ALPHA_2": "JE",
        "ISO_3166_1_ALPHA_3": "JEY",
        "centralLat": 49.214439,
        "centralLng": -2.13125,
        "region": "Europe"
    },
    {
        "name": "Jamaica",
        "ISO_3166_1_ALPHA_2": "JM",
        "ISO_3166_1_ALPHA_3": "JAM",
        "centralLat": 18.109581,
        "centralLng": -77.297508,
        "region": "Americas"
    },
    {
        "name": "Jordan",
        "ISO_3166_1_ALPHA_2": "JO",
        "ISO_3166_1_ALPHA_3": "JOR",
        "centralLat": 30.585164,
        "centralLng": 36.238414,
        "region": "MENA"
    },
    {
        "name": "Japan",
        "ISO_3166_1_ALPHA_2": "JP",
        "ISO_3166_1_ALPHA_3": "JPN",
        "centralLat": 36.204824,
        "centralLng": 138.252924,
        "region": "APAC"
    },
    {
        "name": "Kenya",
        "ISO_3166_1_ALPHA_2": "KE",
        "ISO_3166_1_ALPHA_3": "KEN",
        "centralLat": -0.023559,
        "centralLng": 37.906193,
        "region": "Africa"
    },
    {
        "name": "Kyrgyzstan",
        "ISO_3166_1_ALPHA_2": "KG",
        "ISO_3166_1_ALPHA_3": "KGZ",
        "centralLat": 41.20438,
        "centralLng": 74.766098,
        "region": "APAC"
    },
    {
        "name": "Cambodia",
        "ISO_3166_1_ALPHA_2": "KH",
        "ISO_3166_1_ALPHA_3": "KHM",
        "centralLat": 12.565679,
        "centralLng": 104.990963,
        "region": "APAC"
    },
    {
        "name": "Kiribati",
        "ISO_3166_1_ALPHA_2": "KI",
        "ISO_3166_1_ALPHA_3": "KIR",
        "centralLat": -3.370417,
        "centralLng": -168.734039,
        "region": "APAC"
    },
    {
        "name": "Comoros",
        "ISO_3166_1_ALPHA_2": "KM",
        "ISO_3166_1_ALPHA_3": "COM",
        "centralLat": -11.875001,
        "centralLng": 43.872219,
        "region": "Africa"
    },
    {
        "name": "Saint Kitts and Nevis",
        "ISO_3166_1_ALPHA_2": "KN",
        "ISO_3166_1_ALPHA_3": "KNA",
        "centralLat": 17.357822,
        "centralLng": -62.782998,
        "region": "Americas"
    },
    {
        "name": "North Korea",
        "ISO_3166_1_ALPHA_2": "KP",
        "ISO_3166_1_ALPHA_3": "PRK",
        "centralLat": 40.339852,
        "centralLng": 127.510093,
        "region": "APAC"
    },
    {
        "name": "South Korea",
        "ISO_3166_1_ALPHA_2": "KR",
        "ISO_3166_1_ALPHA_3": "KOR",
        "centralLat": 35.907757,
        "centralLng": 127.766922,
        "region": "APAC"
    },
    {
        "name": "Kuwait",
        "ISO_3166_1_ALPHA_2": "KW",
        "ISO_3166_1_ALPHA_3": "KWT",
        "centralLat": 29.31166,
        "centralLng": 47.481766,
        "region": "MENA"
    },
    {
        "name": "Cayman Islands",
        "ISO_3166_1_ALPHA_2": "KY",
        "ISO_3166_1_ALPHA_3": "CYM",
        "centralLat": 19.513469,
        "centralLng": -80.566956,
        "region": "Americas"
    },
    {
        "name": "Kazakhstan",
        "ISO_3166_1_ALPHA_2": "KZ",
        "ISO_3166_1_ALPHA_3": "KAZ",
        "centralLat": 48.019573,
        "centralLng": 66.923684,
        "region": "APAC"
    },
    {
        "name": "Laos",
        "ISO_3166_1_ALPHA_2": "LA",
        "ISO_3166_1_ALPHA_3": "LAO",
        "centralLat": 19.85627,
        "centralLng": 102.495496,
        "region": "APAC"
    },
    {
        "name": "Lebanon",
        "ISO_3166_1_ALPHA_2": "LB",
        "ISO_3166_1_ALPHA_3": "LBN",
        "centralLat": 33.854721,
        "centralLng": 35.862285,
        "region": "MENA"
    },
    {
        "name": "Saint Lucia",
        "ISO_3166_1_ALPHA_2": "LC",
        "ISO_3166_1_ALPHA_3": "LCA",
        "centralLat": 13.909444,
        "centralLng": -60.978893,
        "region": "Americas"
    },
    {
        "name": "Liechtenstein",
        "ISO_3166_1_ALPHA_2": "LI",
        "ISO_3166_1_ALPHA_3": "LIE",
        "centralLat": 47.166,
        "centralLng": 9.555373,
        "region": "Europe"
    },
    {
        "name": "Sri Lanka",
        "ISO_3166_1_ALPHA_2": "LK",
        "ISO_3166_1_ALPHA_3": "LKA",
        "centralLat": 7.873054,
        "centralLng": 80.771797,
        "region": "APAC"
    },
    {
        "name": "Liberia",
        "ISO_3166_1_ALPHA_2": "LR",
        "ISO_3166_1_ALPHA_3": "LBR",
        "centralLat": 6.428055,
        "centralLng": -9.429499,
        "region": "Africa"
    },
    {
        "name": "Lesotho",
        "ISO_3166_1_ALPHA_2": "LS",
        "ISO_3166_1_ALPHA_3": "LSO",
        "centralLat": -29.609988,
        "centralLng": 28.233608,
        "region": "Africa"
    },
    {
        "name": "Lithuania",
        "ISO_3166_1_ALPHA_2": "LT",
        "ISO_3166_1_ALPHA_3": "LTU",
        "centralLat": 55.169438,
        "centralLng": 23.881275,
        "region": "Europe"
    },
    {
        "name": "Luxembourg",
        "ISO_3166_1_ALPHA_2": "LU",
        "ISO_3166_1_ALPHA_3": "LUX",
        "centralLat": 49.815273,
        "centralLng": 6.129583,
        "region": "Europe"
    },
    {
        "name": "Latvia",
        "ISO_3166_1_ALPHA_2": "LV",
        "ISO_3166_1_ALPHA_3": "LVA",
        "centralLat": 56.879635,
        "centralLng": 24.603189,
        "region": "Europe"
    },
    {
        "name": "Libya",
        "ISO_3166_1_ALPHA_2": "LY",
        "ISO_3166_1_ALPHA_3": "LBY",
        "centralLat": 26.3351,
        "centralLng": 17.228331,
        "region": "MENA"
    },
    {
        "name": "Morocco",
        "ISO_3166_1_ALPHA_2": "MA",
        "ISO_3166_1_ALPHA_3": "MAR",
        "centralLat": 31.791702,
        "centralLng": -7.09262,
        "region": "MENA"
    },
    {
        "name": "Monaco",
        "ISO_3166_1_ALPHA_2": "MC",
        "ISO_3166_1_ALPHA_3": "MCO",
        "centralLat": 43.750298,
        "centralLng": 7.412841,
        "region": "Europe"
    },
    {
        "name": "Moldova",
        "ISO_3166_1_ALPHA_2": "MD",
        "ISO_3166_1_ALPHA_3": "MDA",
        "centralLat": 47.411631,
        "centralLng": 28.369885,
        "region": "Europe"
    },
    {
        "name": "Montenegro",
        "ISO_3166_1_ALPHA_2": "ME",
        "ISO_3166_1_ALPHA_3": "MNE",
        "centralLat": 42.708678,
        "centralLng": 19.37439,
        "region": "Europe"
    },
    {
        "name": "Madagascar",
        "ISO_3166_1_ALPHA_2": "MG",
        "ISO_3166_1_ALPHA_3": "MDG",
        "centralLat": -18.766947,
        "centralLng": 46.869107,
        "region": "Africa"
    },
    {
        "name": "Marshall Islands",
        "ISO_3166_1_ALPHA_2": "MH",
        "ISO_3166_1_ALPHA_3": "MHL",
        "centralLat": 7.131474,
        "centralLng": 171.184478,
        "region": "APAC"
    },
    {
        "name": "Macedonia [FYROM]",
        "ISO_3166_1_ALPHA_2": "MK",
        "ISO_3166_1_ALPHA_3": "MKD",
        "centralLat": 41.608635,
        "centralLng": 21.745275,
        "region": "Europe"
    },
    {
        "name": "Mali",
        "ISO_3166_1_ALPHA_2": "ML",
        "ISO_3166_1_ALPHA_3": "MLI",
        "centralLat": 17.570692,
        "centralLng": -3.996166,
        "region": "Africa"
    },
    {
        "name": "Myanmar [Burma]",
        "ISO_3166_1_ALPHA_2": "MM",
        "ISO_3166_1_ALPHA_3": "MMR",
        "centralLat": 21.913965,
        "centralLng": 95.956223,
        "region": "APAC"
    },
    {
        "name": "Mongolia",
        "ISO_3166_1_ALPHA_2": "MN",
        "ISO_3166_1_ALPHA_3": "MNG",
        "centralLat": 46.862496,
        "centralLng": 103.846656,
        "region": "APAC"
    },
    {
        "name": "Macau",
        "ISO_3166_1_ALPHA_2": "MO",
        "ISO_3166_1_ALPHA_3": "MAC",
        "centralLat": 22.198745,
        "centralLng": 113.543873,
        "region": "APAC"
    },
    {
        "name": "Northern Mariana Islands",
        "ISO_3166_1_ALPHA_2": "MP",
        "ISO_3166_1_ALPHA_3": "MNP",
        "centralLat": 17.33083,
        "centralLng": 145.38469,
        "region": "APAC"
    },
    {
        "name": "Martinique",
        "ISO_3166_1_ALPHA_2": "MQ",
        "ISO_3166_1_ALPHA_3": "MTQ",
        "centralLat": 14.641528,
        "centralLng": -61.024174,
        "region": "Americas"
    },
    {
        "name": "Mauritania",
        "ISO_3166_1_ALPHA_2": "MR",
        "ISO_3166_1_ALPHA_3": "MRT",
        "centralLat": 21.00789,
        "centralLng": -10.940835,
        "region": "Africa"
    },
    {
        "name": "Montserrat",
        "ISO_3166_1_ALPHA_2": "MS",
        "ISO_3166_1_ALPHA_3": "MSR",
        "centralLat": 16.742498,
        "centralLng": -62.187366,
        "region": "Americas"
    },
    {
        "name": "Malta",
        "ISO_3166_1_ALPHA_2": "MT",
        "ISO_3166_1_ALPHA_3": "MLT",
        "centralLat": 35.937496,
        "centralLng": 14.375416,
        "region": "Europe"
    },
    {
        "name": "Mauritius",
        "ISO_3166_1_ALPHA_2": "MU",
        "ISO_3166_1_ALPHA_3": "MUS",
        "centralLat": -20.348404,
        "centralLng": 57.552152,
        "region": "Africa"
    },
    {
        "name": "Maldives",
        "ISO_3166_1_ALPHA_2": "MV",
        "ISO_3166_1_ALPHA_3": "MDV",
        "centralLat": 3.202778,
        "centralLng": 73.22068,
        "region": "APAC"
    },
    {
        "name": "Malawi",
        "ISO_3166_1_ALPHA_2": "MW",
        "ISO_3166_1_ALPHA_3": "MWI",
        "centralLat": -13.254308,
        "centralLng": 34.301525,
        "region": "Africa"
    },
    {
        "name": "Mexico",
        "ISO_3166_1_ALPHA_2": "MX",
        "ISO_3166_1_ALPHA_3": "MEX",
        "centralLat": 23.634501,
        "centralLng": -102.552784,
        "region": "Americas"
    },
    {
        "name": "Malaysia",
        "ISO_3166_1_ALPHA_2": "MY",
        "ISO_3166_1_ALPHA_3": "MYS",
        "centralLat": 4.210484,
        "centralLng": 101.975766,
        "region": "APAC"
    },
    {
        "name": "Mozambique",
        "ISO_3166_1_ALPHA_2": "MZ",
        "ISO_3166_1_ALPHA_3": "MOZ",
        "centralLat": -18.665695,
        "centralLng": 35.529562,
        "region": "Africa"
    },
    {
        "name": "Namibia",
        "ISO_3166_1_ALPHA_2": "NA",
        "ISO_3166_1_ALPHA_3": "NAM",
        "centralLat": -22.95764,
        "centralLng": 18.49041,
        "region": "Africa"
    },
    {
        "name": "New Caledonia",
        "ISO_3166_1_ALPHA_2": "NC",
        "ISO_3166_1_ALPHA_3": "NCL",
        "centralLat": -20.904305,
        "centralLng": 165.618042,
        "region": "APAC"
    },
    {
        "name": "Niger",
        "ISO_3166_1_ALPHA_2": "NE",
        "ISO_3166_1_ALPHA_3": "NER",
        "centralLat": 17.607789,
        "centralLng": 8.081666,
        "region": "Africa"
    },
    {
        "name": "Norfolk Island",
        "ISO_3166_1_ALPHA_2": "NF",
        "ISO_3166_1_ALPHA_3": "NFK",
        "centralLat": -29.040835,
        "centralLng": 167.954712,
        "region": "APAC"
    },
    {
        "name": "Nigeria",
        "ISO_3166_1_ALPHA_2": "NG",
        "ISO_3166_1_ALPHA_3": "NGA",
        "centralLat": 9.081999,
        "centralLng": 8.675277,
        "region": "Africa"
    },
    {
        "name": "Nicaragua",
        "ISO_3166_1_ALPHA_2": "NI",
        "ISO_3166_1_ALPHA_3": "NIC",
        "centralLat": 12.865416,
        "centralLng": -85.207229,
        "region": "Americas"
    },
    {
        "name": "Netherlands",
        "ISO_3166_1_ALPHA_2": "NL",
        "ISO_3166_1_ALPHA_3": "NLD",
        "centralLat": 52.132633,
        "centralLng": 5.291266,
        "region": "Europe"
    },
    {
        "name": "Norway",
        "ISO_3166_1_ALPHA_2": "NO",
        "ISO_3166_1_ALPHA_3": "NOR",
        "centralLat": 60.472024,
        "centralLng": 8.468946,
        "region": "Europe"
    },
    {
        "name": "Nepal",
        "ISO_3166_1_ALPHA_2": "NP",
        "ISO_3166_1_ALPHA_3": "NPL",
        "centralLat": 28.394857,
        "centralLng": 84.124008,
        "region": "APAC"
    },
    {
        "name": "Nauru",
        "ISO_3166_1_ALPHA_2": "NR",
        "ISO_3166_1_ALPHA_3": "NRU",
        "centralLat": -0.522778,
        "centralLng": 166.931503,
        "region": "APAC"
    },
    {
        "name": "Niue",
        "ISO_3166_1_ALPHA_2": "NU",
        "ISO_3166_1_ALPHA_3": "NIU",
        "centralLat": -19.054445,
        "centralLng": -169.867233,
        "region": "APAC"
    },
    {
        "name": "New Zealand",
        "ISO_3166_1_ALPHA_2": "NZ",
        "ISO_3166_1_ALPHA_3": "NZL",
        "centralLat": -40.900557,
        "centralLng": 174.885971,
        "region": "APAC"
    },
    {
        "name": "Oman",
        "ISO_3166_1_ALPHA_2": "OM",
        "ISO_3166_1_ALPHA_3": "OMN",
        "centralLat": 21.512583,
        "centralLng": 55.923255,
        "region": "MENA"
    },
    {
        "name": "Panama",
        "ISO_3166_1_ALPHA_2": "PA",
        "ISO_3166_1_ALPHA_3": "PAN",
        "centralLat": 8.537981,
        "centralLng": -80.782127,
        "region": "Americas"
    },
    {
        "name": "Peru",
        "ISO_3166_1_ALPHA_2": "PE",
        "ISO_3166_1_ALPHA_3": "PER",
        "centralLat": -9.189967,
        "centralLng": -75.015152,
        "region": "Americas"
    },
    {
        "name": "French Polynesia",
        "ISO_3166_1_ALPHA_2": "PF",
        "ISO_3166_1_ALPHA_3": "PYF",
        "centralLat": -17.679742,
        "centralLng": -149.406843,
        "region": "APAC"
    },
    {
        "name": "Papua New Guinea",
        "ISO_3166_1_ALPHA_2": "PG",
        "ISO_3166_1_ALPHA_3": "PNG",
        "centralLat": -6.314993,
        "centralLng": 143.95555,
        "region": "APAC"
    },
    {
        "name": "Philippines",
        "ISO_3166_1_ALPHA_2": "PH",
        "ISO_3166_1_ALPHA_3": "PHL",
        "centralLat": 12.879721,
        "centralLng": 121.774017,
        "region": "APAC"
    },
    {
        "name": "Pakistan",
        "ISO_3166_1_ALPHA_2": "PK",
        "ISO_3166_1_ALPHA_3": "PAK",
        "centralLat": 30.375321,
        "centralLng": 69.345116,
        "region": "APAC"
    },
    {
        "name": "Poland",
        "ISO_3166_1_ALPHA_2": "PL",
        "ISO_3166_1_ALPHA_3": "POL",
        "centralLat": 51.919438,
        "centralLng": 19.145136,
        "region": "Europe"
    },
    {
        "name": "Saint Pierre and Miquelon",
        "ISO_3166_1_ALPHA_2": "PM",
        "ISO_3166_1_ALPHA_3": "SPM",
        "centralLat": 46.941936,
        "centralLng": -56.27111,
        "region": "Americas"
    },
    {
        "name": "Pitcairn Islands",
        "ISO_3166_1_ALPHA_2": "PN",
        "ISO_3166_1_ALPHA_3": "PCN",
        "centralLat": -24.703615,
        "centralLng": -127.439308,
        "region": "APAC"
    },
    {
        "name": "Puerto Rico",
        "ISO_3166_1_ALPHA_2": "PR",
        "ISO_3166_1_ALPHA_3": "PRI",
        "centralLat": 18.220833,
        "centralLng": -66.590149,
        "region": "Americas"
    },
    {
        "name": "Palestinian Territories",
        "ISO_3166_1_ALPHA_2": "PS",
        "ISO_3166_1_ALPHA_3": "PSE",
        "centralLat": 31.952162,
        "centralLng": 35.233154,
        "region": "MENA"
    },
    {
        "name": "Portugal",
        "ISO_3166_1_ALPHA_2": "PT",
        "ISO_3166_1_ALPHA_3": "PRT",
        "centralLat": 39.399872,
        "centralLng": -8.224454,
        "region": "Europe"
    },
    {
        "name": "Palau",
        "ISO_3166_1_ALPHA_2": "PW",
        "ISO_3166_1_ALPHA_3": "PLW",
        "centralLat": 7.51498,
        "centralLng": 134.58252,
        "region": "APAC"
    },
    {
        "name": "Paraguay",
        "ISO_3166_1_ALPHA_2": "PY",
        "ISO_3166_1_ALPHA_3": "PRY",
        "centralLat": -23.442503,
        "centralLng": -58.443832,
        "region": "Americas"
    },
    {
        "name": "Qatar",
        "ISO_3166_1_ALPHA_2": "QA",
        "ISO_3166_1_ALPHA_3": "QAT",
        "centralLat": 25.354826,
        "centralLng": 51.183884,
        "region": "MENA"
    },
    {
        "name": "Réunion",
        "ISO_3166_1_ALPHA_2": "RE",
        "ISO_3166_1_ALPHA_3": "REU",
        "centralLat": -21.115141,
        "centralLng": 55.536384,
        "region": "Africa"
    },
    {
        "name": "Romania",
        "ISO_3166_1_ALPHA_2": "RO",
        "ISO_3166_1_ALPHA_3": "ROU",
        "centralLat": 45.943161,
        "centralLng": 24.96676,
        "region": "Europe"
    },
    {
        "name": "Serbia",
        "ISO_3166_1_ALPHA_2": "RS",
        "ISO_3166_1_ALPHA_3": "SRB",
        "centralLat": 44.016521,
        "centralLng": 21.005859,
        "region": "Europe"
    },
    {
        "name": "Russia",
        "ISO_3166_1_ALPHA_2": "RU",
        "ISO_3166_1_ALPHA_3": "RUS",
        "centralLat": 61.52401,
        "centralLng": 105.318756,
        "region": "Europe"
    },
    {
        "name": "Rwanda",
        "ISO_3166_1_ALPHA_2": "RW",
        "ISO_3166_1_ALPHA_3": "RWA",
        "centralLat": -1.940278,
        "centralLng": 29.873888,
        "region": "Africa"
    },
    {
        "name": "Saudi Arabia",
        "ISO_3166_1_ALPHA_2": "SA",
        "ISO_3166_1_ALPHA_3": "SAU",
        "centralLat": 23.885942,
        "centralLng": 45.079162,
        "region": "MENA"
    },
    {
        "name": "Solomon Islands",
        "ISO_3166_1_ALPHA_2": "SB",
        "ISO_3166_1_ALPHA_3": "SLB",
        "centralLat": -9.64571,
        "centralLng": 160.156194,
        "region": "APAC"
    },
    {
        "name": "Seychelles",
        "ISO_3166_1_ALPHA_2": "SC",
        "ISO_3166_1_ALPHA_3": "SYC",
        "centralLat": -4.679574,
        "centralLng": 55.491977,
        "region": "Africa"
    },
    {
        "name": "Sudan",
        "ISO_3166_1_ALPHA_2": "SD",
        "ISO_3166_1_ALPHA_3": "SDN",
        "centralLat": 12.862807,
        "centralLng": 30.217636,
        "region": "Africa"
    },
    {
        "name": "South Sudan",
        "ISO_3166_1_ALPHA_2": "SS",
        "ISO_3166_1_ALPHA_3": "SSD",
        "centralLat": 0,
        "centralLng": 0,
        "region": "Africa"
    },
    {
        "name": "Sweden",
        "ISO_3166_1_ALPHA_2": "SE",
        "ISO_3166_1_ALPHA_3": "SWE",
        "centralLat": 60.128161,
        "centralLng": 18.643501,
        "region": "Europe"
    },
    {
        "name": "Singapore",
        "ISO_3166_1_ALPHA_2": "SG",
        "ISO_3166_1_ALPHA_3": "SGP",
        "centralLat": 1.352083,
        "centralLng": 103.819836,
        "region": "APAC"
    },
    {
        "name": "Saint Helena",
        "ISO_3166_1_ALPHA_2": "SH",
        "ISO_3166_1_ALPHA_3": "SHN",
        "centralLat": -24.143474,
        "centralLng": -10.030696,
        "region": "Africa"
    },
    {
        "name": "Slovenia",
        "ISO_3166_1_ALPHA_2": "SI",
        "ISO_3166_1_ALPHA_3": "SVN",
        "centralLat": 46.151241,
        "centralLng": 14.995463,
        "region": "Europe"
    },
    {
        "name": "Svalbard and Jan Mayen",
        "ISO_3166_1_ALPHA_2": "SJ",
        "ISO_3166_1_ALPHA_3": "SJM",
        "centralLat": 77.553604,
        "centralLng": 23.670272,
        "region": "Europe"
    },
    {
        "name": "Slovakia",
        "ISO_3166_1_ALPHA_2": "SK",
        "ISO_3166_1_ALPHA_3": "SVK",
        "centralLat": 48.669026,
        "centralLng": 19.699024,
        "region": "Europe"
    },
    {
        "name": "Sierra Leone",
        "ISO_3166_1_ALPHA_2": "SL",
        "ISO_3166_1_ALPHA_3": "SLE",
        "centralLat": 8.460555,
        "centralLng": -11.779889,
        "region": "Africa"
    },
    {
        "name": "San Marino",
        "ISO_3166_1_ALPHA_2": "SM",
        "ISO_3166_1_ALPHA_3": "SMR",
        "centralLat": 43.94236,
        "centralLng": 12.457777,
        "region": "Europe"
    },
    {
        "name": "Senegal",
        "ISO_3166_1_ALPHA_2": "SN",
        "ISO_3166_1_ALPHA_3": "SEN",
        "centralLat": 14.497401,
        "centralLng": -14.452362,
        "region": "Africa"
    },
    {
        "name": "Somalia",
        "ISO_3166_1_ALPHA_2": "SO",
        "ISO_3166_1_ALPHA_3": "SOM",
        "centralLat": 5.152149,
        "centralLng": 46.199616,
        "region": "Africa"
    },
    {
        "name": "Suriname",
        "ISO_3166_1_ALPHA_2": "SR",
        "ISO_3166_1_ALPHA_3": "SUR",
        "centralLat": 3.919305,
        "centralLng": -56.027783,
        "region": "Americas"
    },
    {
        "name": "São Tomé and Príncipe",
        "ISO_3166_1_ALPHA_2": "ST",
        "ISO_3166_1_ALPHA_3": "STP",
        "centralLat": 0.18636,
        "centralLng": 6.613081,
        "region": "Africa"
    },
    {
        "name": "El Salvador",
        "ISO_3166_1_ALPHA_2": "SV",
        "ISO_3166_1_ALPHA_3": "SLV",
        "centralLat": 13.794185,
        "centralLng": -88.89653,
        "region": "Americas"
    },
    {
        "name": "Syria",
        "ISO_3166_1_ALPHA_2": "SY",
        "ISO_3166_1_ALPHA_3": "SYR",
        "centralLat": 34.802075,
        "centralLng": 38.996815,
        "region": "MENA"
    },
    {
        "name": "Eswatini",
        "ISO_3166_1_ALPHA_2": "SZ",
        "ISO_3166_1_ALPHA_3": "SWZ",
        "centralLat": -26.522503,
        "centralLng": 31.465866,
        "region": "Africa"
    },
    {
        "name": "Turks and Caicos Islands",
        "ISO_3166_1_ALPHA_2": "TC",
        "ISO_3166_1_ALPHA_3": "TCA",
        "centralLat": 21.694025,
        "centralLng": -71.797928,
        "region": "Americas"
    },
    {
        "name": "Chad",
        "ISO_3166_1_ALPHA_2": "TD",
        "ISO_3166_1_ALPHA_3": "TCD",
        "centralLat": 15.454166,
        "centralLng": 18.732207,
        "region": "Africa"
    },
    {
        "name": "French Southern Territories",
        "ISO_3166_1_ALPHA_2": "TF",
        "ISO_3166_1_ALPHA_3": "ATF",
        "centralLat": -49.280366,
        "centralLng": 69.348557,
        "region": "APAC"
    },
    {
        "name": "Togo",
        "ISO_3166_1_ALPHA_2": "TG",
        "ISO_3166_1_ALPHA_3": "TGO",
        "centralLat": 8.619543,
        "centralLng": 0.824782,
        "region": "Africa"
    },
    {
        "name": "Thailand",
        "ISO_3166_1_ALPHA_2": "TH",
        "ISO_3166_1_ALPHA_3": "THA",
        "centralLat": 15.870032,
        "centralLng": 100.992541,
        "region": "APAC"
    },
    {
        "name": "Tajikistan",
        "ISO_3166_1_ALPHA_2": "TJ",
        "ISO_3166_1_ALPHA_3": "TJK",
        "centralLat": 38.861034,
        "centralLng": 71.276093,
        "region": "APAC"
    },
    {
        "name": "Tokelau",
        "ISO_3166_1_ALPHA_2": "TK",
        "ISO_3166_1_ALPHA_3": "TKL",
        "centralLat": -8.967363,
        "centralLng": -171.855881,
        "region": "APAC"
    },
    {
        "name": "Timor-Leste",
        "ISO_3166_1_ALPHA_2": "TL",
        "ISO_3166_1_ALPHA_3": "TLS",
        "centralLat": -8.874217,
        "centralLng": 125.727539,
        "region": "APAC"
    },
    {
        "name": "Turkmenistan",
        "ISO_3166_1_ALPHA_2": "TM",
        "ISO_3166_1_ALPHA_3": "TKM",
        "centralLat": 38.969719,
        "centralLng": 59.556278,
        "region": "APAC"
    },
    {
        "name": "Tunisia",
        "ISO_3166_1_ALPHA_2": "TN",
        "ISO_3166_1_ALPHA_3": "TUN",
        "centralLat": 33.886917,
        "centralLng": 9.537499,
        "region": "MENA"
    },
    {
        "name": "Tonga",
        "ISO_3166_1_ALPHA_2": "TO",
        "ISO_3166_1_ALPHA_3": "TON",
        "centralLat": -21.178986,
        "centralLng": -175.198242,
        "region": "APAC"
    },
    {
        "name": "Turkey",
        "ISO_3166_1_ALPHA_2": "TR",
        "ISO_3166_1_ALPHA_3": "TUR",
        "centralLat": 38.963745,
        "centralLng": 35.243322,
        "region": "APAC"
    },
    {
        "name": "Trinidad and Tobago",
        "ISO_3166_1_ALPHA_2": "TT",
        "ISO_3166_1_ALPHA_3": "TTO",
        "centralLat": 10.691803,
        "centralLng": -61.222503,
        "region": "Americas"
    },
    {
        "name": "Tuvalu",
        "ISO_3166_1_ALPHA_2": "TV",
        "ISO_3166_1_ALPHA_3": "TUV",
        "centralLat": -7.109535,
        "centralLng": 177.64933,
        "region": "APAC"
    },
    {
        "name": "Taiwan",
        "ISO_3166_1_ALPHA_2": "TW",
        "ISO_3166_1_ALPHA_3": "TWN",
        "centralLat": 23.69781,
        "centralLng": 120.960515,
        "region": "APAC"
    },
    {
        "name": "Tanzania",
        "ISO_3166_1_ALPHA_2": "TZ",
        "ISO_3166_1_ALPHA_3": "TZA",
        "centralLat": -6.369028,
        "centralLng": 34.888822,
        "region": "Africa"
    },
    {
        "name": "Ukraine",
        "ISO_3166_1_ALPHA_2": "UA",
        "ISO_3166_1_ALPHA_3": "UKR",
        "centralLat": 48.379433,
        "centralLng": 31.16558,
        "region": "Europe"
    },
    {
        "name": "Uganda",
        "ISO_3166_1_ALPHA_2": "UG",
        "ISO_3166_1_ALPHA_3": "UGA",
        "centralLat": 1.373333,
        "centralLng": 32.290275,
        "region": "Africa"
    },
    {
        "name": "United States",
        "ISO_3166_1_ALPHA_2": "US",
        "ISO_3166_1_ALPHA_3": "USA",
        "centralLat": 37.09024,
        "centralLng": -95.712891,
        "region": "Americas"
    },
    {
        "name": "Uruguay",
        "ISO_3166_1_ALPHA_2": "UY",
        "ISO_3166_1_ALPHA_3": "URY",
        "centralLat": -32.522779,
        "centralLng": -55.765835,
        "region": "Americas"
    },
    {
        "name": "Uzbekistan",
        "ISO_3166_1_ALPHA_2": "UZ",
        "ISO_3166_1_ALPHA_3": "UZB",
        "centralLat": 41.377491,
        "centralLng": 64.585262,
        "region": "APAC"
    },
    {
        "name": "Vatican City",
        "ISO_3166_1_ALPHA_2": "VA",
        "ISO_3166_1_ALPHA_3": "VAT",
        "centralLat": 41.902916,
        "centralLng": 12.453389,
        "region": "Europe"
    },
    {
        "name": "Saint Vincent and the Grenadines",
        "ISO_3166_1_ALPHA_2": "VC",
        "ISO_3166_1_ALPHA_3": "VCT",
        "centralLat": 12.984305,
        "centralLng": -61.287228,
        "region": "Americas"
    },
    {
        "name": "Venezuela",
        "ISO_3166_1_ALPHA_2": "VE",
        "ISO_3166_1_ALPHA_3": "VEN",
        "centralLat": 6.42375,
        "centralLng": -66.58973,
        "region": "Americas"
    },
    {
        "name": "British Virgin Islands",
        "ISO_3166_1_ALPHA_2": "VG",
        "ISO_3166_1_ALPHA_3": "VGB",
        "centralLat": 18.420695,
        "centralLng": -64.639968,
        "region": "Americas"
    },
    {
        "name": "U.S. Virgin Islands",
        "ISO_3166_1_ALPHA_2": "VI",
        "ISO_3166_1_ALPHA_3": "VIR",
        "centralLat": 18.335765,
        "centralLng": -64.896335,
        "region": "Americas"
    },
    {
        "name": "Vietnam",
        "ISO_3166_1_ALPHA_2": "VN",
        "ISO_3166_1_ALPHA_3": "VNM",
        "centralLat": 14.058324,
        "centralLng": 108.277199,
        "region": "APAC"
    },
    {
        "name": "Vanuatu",
        "ISO_3166_1_ALPHA_2": "VU",
        "ISO_3166_1_ALPHA_3": "VUT",
        "centralLat": -15.376706,
        "centralLng": 166.959158,
        "region": "APAC"
    },
    {
        "name": "Wallis and Futuna",
        "ISO_3166_1_ALPHA_2": "WF",
        "ISO_3166_1_ALPHA_3": "WLF",
        "centralLat": -13.768752,
        "centralLng": -177.156097,
        "region": "APAC"
    },
    {
        "name": "Samoa",
        "ISO_3166_1_ALPHA_2": "WS",
        "ISO_3166_1_ALPHA_3": "WSM",
        "centralLat": -13.759029,
        "centralLng": -172.104629,
        "region": "APAC"
    },
    {
        "name": "Kosovo",
        "ISO_3166_1_ALPHA_2": "XK",
        "ISO_3166_1_ALPHA_3": null,        
        "centralLat": 42.602636,
        "centralLng": 20.902977,
        "region": "Europe"
    },
    {
        "name": "Yemen",
        "ISO_3166_1_ALPHA_2": "YE",
        "ISO_3166_1_ALPHA_3": "YEM",
        "centralLat": 15.552727,
        "centralLng": 48.516388,
        "region": "MENA"
    },
    {
        "name": "Mayotte",
        "ISO_3166_1_ALPHA_2": "YT",
        "ISO_3166_1_ALPHA_3": "MYT",
        "centralLat": -12.8275,
        "centralLng": 45.166244,
        "region": "Africa"
    },
    {
        "name": "South Africa",
        "ISO_3166_1_ALPHA_2": "ZA",
        "ISO_3166_1_ALPHA_3": "ZAF",
        "centralLat": -30.559482,
        "centralLng": 22.937506,
        "region": "Africa"
    },
    {
        "name": "Zambia",
        "ISO_3166_1_ALPHA_2": "ZM",
        "ISO_3166_1_ALPHA_3": "ZMB",
        "centralLat": -13.133897,
        "centralLng": 27.849332,
        "region": "Africa"
    },
    {
        "name": "Zimbabwe",
        "ISO_3166_1_ALPHA_2": "ZW",
        "ISO_3166_1_ALPHA_3": "ZWE",
        "centralLat": -19.015438,
        "centralLng": 29.154857,
        "region": "Africa"
    },
    {
        "name": "Saint Martin",
        "ISO_3166_1_ALPHA_2": "MF",
        "ISO_3166_1_ALPHA_3": "MAF",
        "centralLat": 18.075277,
        "centralLng": -63.060001,
        "region": "Americas"
    },
    {
        "name": "Åland Islands",
        "ISO_3166_1_ALPHA_2": "AX",
        "ISO_3166_1_ALPHA_3": "ALA",
        "centralLat": 60.1995487,
        "centralLng": 20.3711715,
        "region": "Europe"
    },
    {
        "name": "Bonaire, Sint Eustatius and Saba",
        "ISO_3166_1_ALPHA_2": "BQ",
        "ISO_3166_1_ALPHA_3": "BES",
        "centralLat": 12.1683718,
        "centralLng": -68.308183,
        "region": "Americas"
    },
    {
        "name": "Curaçao",
        "ISO_3166_1_ALPHA_2": "CW",
        "ISO_3166_1_ALPHA_3": "CUW",
        "centralLat": 12.2135221,
        "centralLng": -68.9495816,
        "region": "Americas"
    },
    {
        "name": "Saint Barthélemy",
        "ISO_3166_1_ALPHA_2": "BL",
        "ISO_3166_1_ALPHA_3": "BLM",
        "centralLat": 17.9139222,
        "centralLng": -62.8338521,
        "region": "Americas"
    },
    {
        "name": "Sint Maarten (Dutch part)",
        "ISO_3166_1_ALPHA_2": "SX",
        "ISO_3166_1_ALPHA_3": "SXM",
        "centralLat": 18.0347188,
        "centralLng": -63.0681114,
        "region": "Americas"
    },
    {
        "name": "United States Minor Outlying Islands",
        "ISO_3166_1_ALPHA_2": "UM",
        "ISO_3166_1_ALPHA_3": "UMI",
        "centralLat": 19.295374,
        "centralLng": 166.6280441,
        "region": "Americas"
    }
]